import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import AppLayout from "@/components/AppLayout";
import Dashboard from "@/pages/Dashboard";
import Assets from "@/pages/Assets";
import AssetDetail from "@/pages/AssetDetail";
import Maintenance from "@/pages/Maintenance";
import Compliance from "@/pages/Compliance";
import Inspections from "@/pages/Inspections";
import Defects from "@/pages/Defects";
import WorkOrders from "@/pages/WorkOrders";
import Suppliers from "@/pages/Suppliers";
import SupplierDetail from "@/pages/SupplierDetail";
import Documents from "@/pages/Documents";
import ImportReview from "@/pages/ImportReview";
import Administration from "@/pages/Administration";
import CalendarPage from "@/pages/CalendarPage";
import Reports from "@/pages/Reports";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="p-8 text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Protected><AppLayout /></Protected>}>
        <Route index element={<Dashboard />} />
        <Route path="assets" element={<Assets />} />
        <Route path="assets/:id" element={<AssetDetail />} />
        <Route path="maintenance" element={<Maintenance />} />
        <Route path="compliance" element={<Compliance />} />
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="inspections" element={<Inspections />} />
        <Route path="defects" element={<Defects />} />
        <Route path="work-orders" element={<WorkOrders />} />
        <Route path="suppliers" element={<Suppliers />} />
        <Route path="suppliers/:id" element={<SupplierDetail />} />
        <Route path="documents" element={<Documents />} />
        <Route path="import-review" element={<ImportReview />} />
        <Route path="administration" element={<Administration />} />
        <Route path="reports" element={<Reports />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}
